import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Төлбөрийн мэдээлэл")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Төлбөр төлөх")
  ])
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        true
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: this.yearValue,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.yearValue) = $event)),
                    "collapse-tags": "",
                    size: "mini",
                    placeholder: "-- Он сонгох --",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.years, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.yearValue,
                          label: item.yearLabel,
                          value: item.yearValue
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: this.monthValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.monthValue) = $event)),
                    "collapse-tags": "",
                    size: "mini",
                    placeholder: "-- Сар сонгох --"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.monthValue,
                          label: item.monthLabel,
                          value: item.monthValue
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_8,
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: 
            this.tableData
              .filter(data => {
                return !this.monthValue || data.month.includes(this.monthValue);
              })
              .filter(data => {
                return !this.yearValue || data.year.includes(this.yearValue);
              })
          ,
              border: "",
              size: "small",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' },
              style: {"width":"100%","margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "60",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Байгууллагын нэр",
                  prop: "orgname",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжлэлийн дугаар",
                  prop: "invoiceNumber",
                  sortable: "",
                  width: "250px"
                }, {
                  default: _withCtx((scope) => [
                    _withDirectives((_openBlock(), _createElementBlock("span", {
                      class: "customized-link-span",
                      onClick: ($event: any) => (_ctx.getInvoice(scope.row.invoiceNumber))
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.invoiceNumber), 1)
                    ], 8, _hoisted_9)), [
                      [
                        _directive_loading,
                        this.downloadInvoice,
                        void 0,
                        {
                          fullscreen: true,
                          lock: true
                        }
                      ]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжилсэн огноо",
                  prop: "invoiceDate",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нэхэмжилсэн дүн (төг)",
                  prop: "invoiceAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөх дүн (төг)",
                  prop: "payableAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлсөн дүн (төг)",
                  prop: "voucherAmount",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөв",
                  prop: "status",
                  sortable: ""
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_tag, {
                      type: 
                  scope.row.status === 'C'
                    ? 'danger'
                    : scope.row.diffStatus === 'D'
                    ? 'warning'
                    : scope.row.diffStatus === 'M'
                    ? 'success'
                    : 'success'
                ,
                      "disable-transitions": ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(scope.row.status === "C"
                    ? "Төлөгдөөгүй"
                    : scope.row.diffStatus === "D"
                    ? "Дутуу төлсөн"
                    : scope.row.diffStatus === "M"
                    ? "Илүү төлсөн"
                    : "Төлөгдсөн"), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Зөрүү дүн",
                  prop: "amntDifference",
                  formatter: _ctx.$filters.formatPrice,
                  sortable: ""
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Төлөгдсөн огноо",
                  prop: "paidDate",
                  sortable: ""
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.loadingTable]
            ])
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}